import { AtualizarRecompensaPayload, listarRecompensasQuery } from '../../interfaces/recompensa'
import BASEURLGESTTOR from '../api/gesttor'

export function listarRecompensas({ titulo, situacao, pagina }: listarRecompensasQuery) {
  return BASEURLGESTTOR.get(`/recompensas?titulo=${titulo || ""}&situacao=${situacao || ""}&pagina=${pagina}`)
}

export function atualizarRecompensa(id: string, payload: AtualizarRecompensaPayload) {
  return BASEURLGESTTOR.patch(`/recompensas/${id}`, payload)
}
